import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';

import {
  newCheckInAction,
  NEW_CHECKIN,
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import Tooltip from '../../components/Tooltip';
import Input from '../../components/Form/Input';
import Validator from '../../components/Validator';
import Progress from '../../components/Progress';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import ApplicationId from '../../components/ApplicationId';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import { numberUnmask } from '../../utils/unmasks';
import imgError from '../../assets/images/error.svg';

import schema from './schema';

const Welcome = (props) => {
  const config = useConfig();
  const dispatch = useDispatch();
  const checkinData = useSelector((state) => state.screen.checkinData);
  const fetch = useSelector((state) => state.fetch);
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);

  const { validator: { values, errors, validate, onChangeHandler }, navigate } = props;

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (isEmpty(checkinData)) {
      dispatch(newCheckInAction({
        key: params.key,
        workflowType: 'dtm-luwa',
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    }
  }, []);

  useEffect(() => {
    if (
      !get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))
      && ((fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`])
      || (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]))
    ) {
      const params = parseUrlParams(window.location.search);
      let routeUrl = get(checkinData, 'data.url').replace(config.hostUrl, '');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [checkinData]);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (validate(schema).isValid) {
      const params = parseUrlParams(window.location.search);
      let formData;
      if (params.to) {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
          to: params.to,
        };
      } else {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
        };
      }
      setIsProgressVisible(true);
      dispatch(newNextAction({
        key: params.key,
        workflowType: 'plaid',
        data: formData,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
          setIsProgressVisible(false);
        },
      }));
    } else {
      console.log(errors);
      setIsPopupVisible(true);
      setIsProgressVisible(false);
    }
  };

  const handleInputChange = (event) => {
    onChangeHandler(event.target.name, event.target.value);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      {get(checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <div className="content" style={{ minHeight: 'calc(100vh - 210px)' }}>
        <h2>
          Welcome back,
          {' '}
          {get(checkinData, 'data.firstName') || get(checkinData, 'data.data.firstName')}
          !
        </h2>
        <p>Please enter the last 4 of your SSN to verify your identity</p>
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="form-group active">
                <Input
                  label="Last 4 Digits of Your SSN"
                  value={values.ssn || ''}
                  name="ssn"
                  tooltip="To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number."
                  isMasked={[/\d/, /\d/, /\d/, /\d/]}
                  onChange={handleInputChange}
                  type="tel"
                  isRequired
                  hasError={errors.ssn}
                />
                <Tooltip>To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number.</Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <Button
              className="btn arrow"
              onClick={handleSubmitForm}
              title="Continue"
              isDisabled={values.ssn === undefined}
            />
          </div>
        </div>
      </div>
      {
        isPopupVisible && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>Please try again.</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
        )
      }
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

Welcome.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
};

export default Validator(schema)(Welcome);
